import type { IMobileControlsProps } from "../../types";
import { Box, IconButton } from "@mui/material";
import { CameraAlt, Close, FlipCameraIos } from "@mui/icons-material";

export default function MobileControls(props: IMobileControlsProps) {
  const { styles, handleChangeCameraMode, handleCapture, handleClose } = props;

  return (
    <Box sx={styles.mobileRoot}>
      <IconButton onClick={handleClose}>
        <Close fontSize="large" />
      </IconButton>

      <IconButton onClick={handleCapture}>
        <CameraAlt fontSize="large" />
      </IconButton>

      <IconButton onClick={handleChangeCameraMode}>
        <FlipCameraIos fontSize="large" />
      </IconButton>
    </Box>
  );
}
